import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { generateReactKey } from "../../../utils/reactKey";

const CalculationToolTabs = ({ match, tabs = [], selectedIndex }) => {
  return (
    <div className="grid">
      <nav className="calculation-tool-tabs" id="tool-tabs-position">
        <ul className="menu">
          {tabs.map((tab, index) => {
            const pathArr = [match.params.lang, match.params.sitecoreRoute.replace(/^\//, ""), "l", tab.path];
            return (
              <li className="tab" key={generateReactKey()}>
                <Link
                  to={`/${pathArr.join("/")}`}
                  onClick={e => {
                    e.preventDefault();
                    tab.onTabClicked(e, tab);
                  }}
                  className={selectedIndex === index ? "active" : undefined}
                >
                  {tab.label}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

CalculationToolTabs.propTypes = {
  match: PropTypes.object,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      label: PropTypes.string
    })
  ),
  selectedIndex: PropTypes.number
};

export default CalculationToolTabs;
